import { DEGRADADO_NUEVO } from './colores-del-logo';
import { lerp } from './curvas';
import { PUNTOS } from './datos-del-rombo';

export const N = PUNTOS.length;

/* El mismo generador y la misma semilla del prototipo: cada apertura es idéntica. */
function generador(semilla: number): () => number {
  let s = semilla;
  return () => {
    s = (s + 0x6d2b79f5) | 0;
    let t = Math.imul(s ^ (s >>> 15), 1 | s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

const rnd = generador(7);

/** De dónde llega cada punto: del fondo de la escena. */
export const SC: ReadonlyArray<readonly [number, number, number]> = PUNTOS.map(() => [
  (rnd() - 0.5) * 44,
  (rnd() - 0.5) * 28,
  -25 - rnd() * 45,
]);
export const R1 = PUNTOS.map(() => rnd());
export const R2 = PUNTOS.map(() => rnd());
export const R3 = PUNTOS.map(() => rnd());

const LEJOS = Math.max(...PUNTOS.map((p) => Math.hypot(p[0], p[1])));
/** Distancia al centro, de 0 a 1. */
export const D = PUNTOS.map((p) => Math.hypot(p[0], p[1]) / LEJOS);

/** El lugar de cada punto, del centro hacia afuera. */
export const RANK: number[] = [];
PUNTOS.map((_, i) => i)
  .sort((a, b) => D[a] - D[b])
  .forEach((i, k) => {
    RANK[i] = k;
  });

export function colorDegradado(t: number): string {
  const f = t * (DEGRADADO_NUEVO.length - 1);
  const k = Math.min(DEGRADADO_NUEVO.length - 2, Math.floor(f));
  const a = parseInt(DEGRADADO_NUEVO[k].slice(1), 16);
  const b = parseInt(DEGRADADO_NUEVO[k + 1].slice(1), 16);
  const canal = (s: number) => Math.round(lerp((a >> s) & 255, (b >> s) & 255, f - k));
  return `rgb(${canal(16)},${canal(8)},${canal(0)})`;
}
